import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';

import { SetValueAction, adapter, setValue } from './slice';

export const localStorage = createListenerMiddleware();

localStorage.startListening({
  matcher: isAnyOf(setValue),

  effect: (action: SetValueAction, listenerApi) => {
    adapter.setItem(action.payload.key, action.payload.value);
  },
});
